import React, { Component } from 'react';
import { compose } from 'recompose';
import { Message, Container, Segment } from 'semantic-ui-react';

import { withFirebase } from '../Firebase';
import { withAuthorization } from '../Session';
import * as ROLES from '../../constants/roles';

class ReportDetailsUser extends Component {
    constructor(props) {
        super(props);
     
        this.state = {
            assignedAdminUid :  this.props.location.state.faultReport.assignedAdminUid,
            assignedAdminName :  this.props.location.state.faultReport.assignedAdminName,
            isAssigned :  this.props.location.state.faultReport.isAssigned,
            faultCategory :  this.props.location.state.faultReport.faultCategory,
            faultOutlet :  this.props.location.state.faultReport.faultOutlet,
            faultDescription :  this.props.location.state.faultReport.faultDescription,
            faultUpdates :  this.props.location.state.faultReport.updates,
            faultStatus :  this.props.location.state.faultReport.faultStatus,
            dateSubmitted : this.props.location.state.faultReport.dateSubmitted,
            attachmentURL :  this.props.location.state.faultReport.attachmentURL,
            downloadURL: [],
        };
    }

    async componentDidMount() {
        const downloadURL = await this.props.firebase
          .fireStorage()
          .child(this.state.attachmentURL)
          .getDownloadURL();
    
        this.setState(oldState => ({
          downloadURL: [...oldState.downloadURL, downloadURL],
        }));
    }

    render() {
        const assignedAdminUid = this.state.assignedAdminUid;
        const assignedAdminName = this.state.assignedAdminName;
        const isAssigned = this.state.isAssigned;
        const faultCategory = this.state.faultCategory;
        const faultOutlet = this.state.faultOutlet;
        const faultDescription = this.state.faultDescription;
        const faultUpdates = this.state.faultUpdates;
        const faultStatus = this.state.faultStatus;
        const dateSubmitted = this.state.dateSubmitted;
        const filenames = this.state.filenames;
        const downloadURLs = this.state.downloadURLs;

        return (
        <Container>
            <hr />
                <div class="ui inverted fluid segment">
                <h1>{faultDescription}</h1>
                </div>
            <p></p>

            <Segment>
                <div class="customFontBlack">
                    <p>Fault Status : { faultStatus }</p>
                    <p>Fault Category : { faultCategory }</p>
                    <p>Fault Outlet : { faultOutlet }</p>
                    <p>Fault Description : { faultDescription }</p>
                    <p>Date Submitted : {dateSubmitted}</p>
                    <p>Assigned Admin Name : { isAssigned ? assignedAdminName : <span>(nil)</span> }</p>
                    <div>
                    <p>Image(s) : </p>
                    {this.state.downloadURL.map((downloadURL, i) => {
                    return <img key={i} src={downloadURL} />;
                    })}
                    </div>
                </div>
           
            <Message>Updates From Admin : { faultUpdates }</Message>
            </Segment>
        </Container>
        );
    }
}

const condition = authUser => authUser && !!authUser.roles[ROLES.USER];
 
export default compose(
  withAuthorization(condition),
  withFirebase,
)(ReportDetailsUser);